<template>
    <ies-form-field :field="field">
        <v-row class="mt-1">
            <v-col cols="12">
                <label class="d-block mb-1 trip-inclusion-subheader">Included</label>
                <v-row dense align="center" class="trip-inclusion-item mb-2" v-for="(item, index) in includedItems" :key="index">
                    <v-col cols="12" sm="9">
                        <v-text-field label="Description" hide-details outlined dense v-model="includedItems[index].description"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" class="text-right">
                        <v-btn icon small title="Move up" v-on:click="moveUp('includedItems', index)" :disabled="index === 0"><v-icon>arrow_upward</v-icon></v-btn>
                        <v-btn icon small title="Move down" v-on:click="moveDown('includedItems', index)" :disabled="index === includedItems.length - 1"><v-icon>arrow_downward</v-icon></v-btn>
                        <v-btn icon small title="Delete" class="ies-coral--text" v-on:click="deleteItem('includedItems', index)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="3" offset-sm="9" class="text-right">
                <v-btn class="ies-green" title="Add Included Item" v-on:click="addIncludedItem()"><v-icon>add</v-icon></v-btn>
            </v-col>

            <v-col cols="12">
                <label class="d-block mb-1 trip-inclusion-subheader">Not Included</label>
                <v-row dense align="center" class="trip-inclusion-item mb-2" v-for="(item, index) in notIncludedItems" :key="index">
                    <v-col cols="12" sm="9">
                        <v-text-field label="Description" hide-details outlined dense v-model="notIncludedItems[index].description"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" class="text-right">
                        <v-btn icon small title="Move up" v-on:click="moveUp('notIncludedItems', index)" :disabled="index === 0"><v-icon>arrow_upward</v-icon></v-btn>
                        <v-btn icon small title="Move down" v-on:click="moveDown('notIncludedItems', index)" :disabled="index === notIncludedItems.length - 1"><v-icon>arrow_downward</v-icon></v-btn>
                        <v-btn icon small title="Delete" class="ies-coral--text" v-on:click="deleteItem('notIncludedItems', index)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="3" offset-sm="9" class="text-right">
                <v-btn class="ies-green" title="Add Not Included Item" v-on:click="addNotIncludedItem()"><v-icon>add</v-icon></v-btn>
            </v-col>

            <input type="hidden" :name="this.field.fieldName" :value="field.value">
        </v-row>
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-input-trip-inclusions',
        props: ['field', 'recordData', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                tripKey: 0,
                includedItems: [],
                notIncludedItems: [],
            }
        },

        created: function() {
            this.tripKey = this.getTripKeyFromUrl();
            if (this.tripKey > 0) {
                this.getInclusions();
            }
            this.syncFieldValue();
        },

        methods: {
            getTripKeyFromUrl: function() {
                if (!this.page || !this.page.edit_url) {
                    return 0;
                }
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index) {
                    if (bit == '{Trip.trip_key}') {
                        foundIndex = index;
                    }
                });
                if (foundIndex === null) {
                    return 0;
                }
                var urlBits = location.pathname.split('/').splice(1);
                return parseInt(urlBits[foundIndex]) || 0;
            },

            getInclusions: function() {
                axios.get('/api/trip-inclusions/' + this.tripKey).then((response) => {
                    if (response.data.inclusions && response.data.inclusions.length) {
                        var includedItems = [];
                        var notIncludedItems = [];
                        response.data.inclusions.forEach(function(inclusion) {
                            var item = {
                                description: inclusion.description,
                                sort_order: inclusion.sort_order,
                            };
                            if (inclusion.is_included == 1) {
                                includedItems.push(item);
                            } else {
                                notIncludedItems.push(item);
                            }
                        });
                        includedItems.sort(function(a, b) { return a.sort_order - b.sort_order; });
                        notIncludedItems.sort(function(a, b) { return a.sort_order - b.sort_order; });
                        this.includedItems = includedItems;
                        this.notIncludedItems = notIncludedItems;
                        this.syncFieldValue();
                    }
                });
            },

            addIncludedItem: function() {
                this.includedItems.push({ description: '', sort_order: this.includedItems.length });
            },

            addNotIncludedItem: function() {
                this.notIncludedItems.push({ description: '', sort_order: this.notIncludedItems.length });
            },

            deleteItem: function(list, index) {
                this[list].splice(index, 1);
            },

            moveUp: function(list, index) {
                if (index === 0) {
                    return;
                }
                var moved = this[list].splice(index, 1)[0];
                this[list].splice(index - 1, 0, moved);
            },

            moveDown: function(list, index) {
                if (index === this[list].length - 1) {
                    return;
                }
                var moved = this[list].splice(index, 1)[0];
                this[list].splice(index + 1, 0, moved);
            },

            syncFieldValue: function() {
                this.field.value = {
                    trip_key: this.tripKey,
                    includedItems: this.includedItems,
                    notIncludedItems: this.notIncludedItems,
                };
            },
        },

        watch: {
            includedItems: {
                handler: function() {
                    this.syncFieldValue();
                },
                deep: true,
            },
            notIncludedItems: {
                handler: function() {
                    this.syncFieldValue();
                },
                deep: true,
            },
        },
    }
</script>

<style scoped>
.trip-inclusion-subheader {
    font-size: 0.875rem;
    line-height: 1.4;
}
</style>


